


































































import { Button, SortableTable } from "@micad/vue-components";
import { QBtn } from "quasar";
import { usersColumns, User } from "@/assets/js/constants";
import { defineComponent, reactive, watch } from "@vue/composition-api";
import { getUsers } from "@/data/repos/userList";
import Loading from "@/components/Loading.vue";
import router from "@/router";
import { TableFilter } from "@micad/vue-components/src/common/interfaces";
import { canIUse } from "@/modules/auth";
import m from "moment";

export interface UserColumn {
  id: number | string;
  name: string;
  label: string;
  align: string;
  field: string;
  classes: string;
  sortable: boolean;
  filter: boolean;
  customBodyRender: boolean;
  value: unknown;
  appRoles?: { [key: string]: string };
}

const filters = [
  {
    name: "email",
    label: "Email address",
    type: "text",
    value: "",
  },
  {
    name: "first_name",
    label: "First name",
    type: "text",
    value: "",
  },
  {
    name: "last_name",
    label: "Last name",
    type: "text",
    value: "",
  },
  {
    name: "organisation",
    label: "Organisation",
    type: "text",
    value: "",
  },
  {
    name: "position",
    label: "Position",
    type: "text",
    value: "",
  },
  {
    name: "directory",
    label: "Directory",
    type: "text",
    value: "",
  },
  {
    name: "startDateTime",
    label: "Created (dd/mm/yyyy)",
    type: "text",
    value: "",
  },
  {
    name: "lastLoginDateTime",
    label: "Last login (dd/mm/yyyy)",
    type: "text",
    value: "",
  },
  {
    name: "module",
    label: "Module",
    type: "select",
    value: null,
    options: [{ label: "All modules", value: "" }],
  },
] as TableFilter[];

export default defineComponent({
  name: "Users",
  components: {
    SortableTable,
    Button,
    Loading,
    QBtn,
  },
  setup(_, ctx) {
    const applyFilters = async (filters: TableFilter[]) => {
      let users = state.allUsers;
      state.loaded = false;

      let rowSearch = function (column: string, searchValue: string) {
        return (column || "").toLowerCase().indexOf(searchValue) > -1;
      };

      const appAppSearch = function (row: User, appId: string) {
        return Object.keys(row.appRoles || {}).reduce((result, key) => {
          return (
            result || (key || "").toLowerCase() === (appId || "").toLowerCase()
          );
        }, false);
      };

      filters.forEach(function (filter: TableFilter) {
        let searchValue = "";
        let sendValue = filter.sendValue;

        switch (filter.name) {
          case "email":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              users = users.filter((row) => rowSearch(row.email, searchValue));
            }
            break;

          case "first_name":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              users = users.filter((row) =>
                rowSearch(row.first_name, searchValue)
              );
            }
            break;

          case "last_name":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              users = users.filter((row) =>
                rowSearch(row.last_name, searchValue)
              );
            }
            break;

          case "organisation":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              users = users.filter((row) =>
                rowSearch(row.organisation, searchValue)
              );
            }
            break;

          case "position":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              users = users.filter((row) =>
                rowSearch(row.position, searchValue)
              );
            }
            break;

          case "directory":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              users = users.filter((row) =>
                rowSearch(row.directory, searchValue)
              );
            }
            break;

          case "module":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              users = users.filter((row) => appAppSearch(row, searchValue));
            }
            break;

          case "startDateTime":
            const startDateTime = m(String(sendValue), "DD/MM/YYYY");
            if (startDateTime.isValid()) {
              users = users.filter((row) =>
                startDateTime.isSame(row.lastLoginDateTime, "date")
              );
            }
            break;

          case "lastLoginDateTime":
            const lastLoginDateTime = m(String(sendValue), "DD/MM/YYYY");
            if (lastLoginDateTime.isValid()) {
              users = users.filter((row) =>
                lastLoginDateTime.isSame(row.lastLoginDateTime, "date")
              );
            }
            break;
        }
      });
      state.users = users;
      state.loaded = true;
    };

    watch(
      () => ctx.root.$route,
      () => {
        if (
          router.currentRoute.name === "Home" &&
          router.currentRoute.params.refresh === "true"
        ) {
          refreshUsers();
        }
      }
    );
    const state = reactive({
      usersColumns,
      users: [] as User[],
      allUsers: [] as User[],
      selected: [] as User[],
      loaded: false,
      progress: false,
      filters,
      emailSelectionMode: false,
      goToCreateUser,
      goToSendEmail,
      actions,
      canIUse,
      applyFilters,
    });
    function extractApps(u: User[]) {
      return u.reduce((result, user) => {
        Object.keys(user.appRoles || {}).forEach((key) => (result[key] = true));
        return result;
      }, {} as { [key: string]: boolean });
    }
    function updateModuleOptions(apps: { [key: string]: boolean }) {
      const idx = filters.findIndex((f) => f.name === "module");
      filters[idx].options = [
        ...(filters[idx].options || []),
        ...Object.keys(apps)
          .sort()
          .map((v) => ({ label: v, value: v })),
      ];
    }
    function refreshUsers() {
      setTimeout(async () => {
        state.progress = true;
        const users = (await getUsers(false)).payload || [];
        state.loaded = true;
        state.users = state.allUsers = users
          .map((u) => {
            return {
              id: u.id,
              email: u.username,
              first_name: u.forename,
              last_name: u.surname,
              phone: "--",
              organisation: u.organisation,
              position: u.position,
              directory: u.directory ? u.directory : "Local",
              address: "--",
              last_activity: u.lastLoginDateTime,
              applications: ["IPR", "FMRP"],
              active: u.active,
              expirationTimestamp: u.expirationTimestamp,
              suspendedDate: u.suspendedDate,
              startDateTime: u.startDateTime,
              lastLoginDateTime: u.lastLoginDateTime,
              appRoles: u.appRoles,
            } as User;
          })
          .filter((u) => u.id !== 0)
          .sort((a: User, b: User) =>
            a.email.toLowerCase() > b.email.toLowerCase() ? 1 : -1
          );
        updateModuleOptions(extractApps(state.users));
        state.progress = false;
        applyFilters(state.filters);
      });
    }
    refreshUsers();
    function goToCreateUser() {
      router.push({ name: "UserCreate" });
    }
    function goToSendEmail(users: UserColumn[]) {
      if (state.emailSelectionMode) {
        state.emailSelectionMode = false;
        router.push({
          name: "SendEmail",
          params: { users: JSON.stringify(users) },
        });
      } else {
        state.emailSelectionMode = true;
      }
    }
    async function actions(col: UserColumn) {
      switch (col.name) {
        case "email":
          let id: string | number = 0;
          state.users.forEach((u) => {
            if (u.email === col.value) id = u.id;
          });
          await router.push({
            name: "UserDetails",
            params: { id: String(id) },
          });
          break;
        case "id":
          await router.push({
            name: "UserDetails",
            params: { id: String(col.value) },
          });
          break;
      }
    }
    return state;
  },
});
